import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { TableSortLabelIcon } from '@/src/materialui/table/TableSortLabelIcon';

export const flowTableSortLabel: Components<Theme>['MuiTableSortLabel'] = {
  defaultProps: {
    // prevent selection, we select IconButton instead
    tabIndex: -1,
    IconComponent: TableSortLabelIcon,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // default styling for both active and inactive
      '&, &.Mui-active': {
        // icon button
        '.MuiTableSortLabel-icon': {
          color: theme.palette.onSurface.os600,
        },
        // hover of whole label and focus of icon button
        '&:hover .MuiTableSortLabel-icon, .MuiTableSortLabel-icon.Mui-focusVisible': {
          color: theme.palette.text.primary,
        },
      },
      // hover of whole label
      '&:hover': {
        // remove default @mui recolor of label
        color: 'inherit',
        // icon button
        '.MuiTableSortLabel-icon': {
          // remove default @mui opacity change on hover
          opacity: '1',
          // hide regular icon
          '& .FlowTableSortLabel-icon': {
            opacity: '0',
          },
          // show filled selected icon
          '& .FlowTableSortLabel-filledIcon': {
            opacity: '1',
          },
        },
      },
      // hover of whole label and focus of icon button
      '&:hover .MuiTableSortLabel-icon, .MuiTableSortLabel-icon.Mui-focusVisible': {
        // hide regular icon
        '& .FlowTableSortLabel-icon': {
          opacity: '0',
        },
        // show filled selected icon
        '& .FlowTableSortLabel-filledIcon': {
          opacity: '1',
        },
      },
      // active state
      '&.Mui-active': {
        // flip filled/regular icons
        '.MuiTableSortLabel-icon': {
          '& .FlowTableSortLabel-icon': {
            opacity: '0',
          },
          '& .FlowTableSortLabel-filledIcon': {
            opacity: '1',
          },
        },
        // hover of whole label and focus of icon button
        '&:hover .MuiTableSortLabel-icon, & .MuiTableSortLabel-icon.Mui-focusVisible': {
          '& .FlowTableSortLabel-icon': {
            opacity: '1',
          },
          '& .FlowTableSortLabel-filledIcon': {
            opacity: '0',
          },
        },
      },
    }),
    // ButtonBase in custom TableSortIcon
    icon: {
      // remove default @mui opacity change, keep always visible
      opacity: '1',
      // increase space between label and button
      margin: '0 8px',
    },
  },
};
